(() => {
	angular.module('main').controller('JobViewController', JobViewController);

	JobViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$filter',
		'$timeout',
		'timeService',
		'messageService',
		'templateRequestsService',
		'validationService',
		'workflowService',
		'stringModifierService',
		'fileUploadService',
		'imageConverter',
		'integrationsDataService',
		'emailService',
		'utilsService',
		'userService',
		'clientsDataService',
		'clientService',
		'jobTypesDataService',
		'workflowDataService',
		'newJobsDataService',
		'fileDownloadDataService',
		'settingsService',
		'fileUploadDataService',
		'mailsDataService'
	];

	function JobViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$filter,
		$timeout,
		timeService,
		messageService,
		templateRequestsService,
		validationService,
		workflowService,
		stringModifierService,
		fileUploadService,
		imageConverter,
		integrationsDataService,
		emailService,
		utilsService,
		userService,
		clientsDataService,
		clientService,
		jobTypesDataService,
		workflowDataService,
		newJobsDataService,
		fileDownloadDataService,
		settingsService,
		fileUploadDataService,
		mailsDataService
	) {
		// Requests
		const jobViewRequests = {
			sendNewContractEmail(data, successCallback, errorCallback) {
				if (id !== null) {
					const maxSize = 10; // 10Mb

					if (
						$scope.attachmentsDataContract &&
						$scope.attachmentsDataContract.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						$scope.initSendContractSpinningWheel = false;
						return false;
					}

					const url = '/protected/rest/job/contract/save/';

					const formData = new FormData();

					angular.forEach(data, (value, key) => {
						formData.append(key, value);
					});

					const filesFromJob = $scope.attachmentsDataContract.attachments.filter(
						file => file.id
					);
					const filesFromComputer = $scope.attachmentsDataContract.attachments.filter(
						file => !file.id
					);

					angular.forEach(filesFromComputer, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(filesFromJob, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});

					$http({
						method: 'POST',
						url,
						data: formData,
						transformRequest: angular.identity,
						headers: {
							'Content-Type': undefined
						}
					}).then(
						result => {
							successCallback(result);
							Intercom('trackEvent', 'sent contract');
						},
						result => {
							errorCallback(result);
						}
					);
				}
			},

			sendNewQuestionnaireEmail(data, successCallback, errorCallback) {
				if (id != null) {
					const maxSize = 10; // 10Mb

					if (
						$scope.attachmentsDataQueston &&
						$scope.attachmentsDataQueston.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					const url = '/protected/rest/job/questionnaire/save';

					const formData = new FormData();

					angular.forEach(data, (value, key) => {
						formData.append(key, value);
					});

					const filesFromJob = $scope.attachmentsDataQueston.attachments.filter(
						file => file.id
					);
					const filesFromComputer = $scope.attachmentsDataQueston.attachments.filter(
						file => !file.id
					);

					angular.forEach(filesFromComputer, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(filesFromJob, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});

					$http({
						method: 'POST',
						url,
						data: formData,
						transformRequest: angular.identity,
						headers: {
							'Content-Type': undefined
						}
					}).then(
						result => {
							successCallback(result);
							Intercom('trackEvent', 'sent questionnaire');
						},
						result => {
							errorCallback(result);
						}
					);
				}
			},

			getJob() {
				const newTaskId = $routeParams.task;
				return newJobsDataService
					.getJobInfo(id, newTaskId)
					.map(data => removeJobMails(data))
					.subscribe(
						data => successGetJobInfo(data),
						error => errorGetJobInfo(error)
					);
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			$rootScope.jobViewLoaded = true;
			$scope.isSaveNotesSpinnningWheelActive = false;
			$scope.files = [];
			$scope.newTaskCreate = [];
			$scope.showAddNewTaskModalSpinnigWheel = false;
			$scope.createNewInvoiceSpinningWheel = false;
			$scope.createNewQuoteSpinningWheel = false;
			$scope.initSendContractSpinningWheel = false;
			$scope.initSendQuestionnaireSpinningWheel = false;
			$scope.showSendEmailModalSpinningWheel = false;

			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isEditContractModalSpinnningWheelActive = false;

			$scope.loadFileSpinningWheelActive = false;

			$scope.userCurrencySymbol = userService.userCurrencySymbol;

			$rootScope.dnd = {
				canMove: true
			};
			const attachmentsObj = {
				attachments: [],
				filesSize: 0
			};
			$scope.attachmentsDataContract = angular.copy(attachmentsObj);
			$scope.tokenAttachmentsData = angular.copy(attachmentsObj);
			window.scrollTo(0, 0);
			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.primaryContact = null;
			$scope.secondaryContact = null;
			$scope.tickTask = false;
			$scope.tickTaskType = '';

			jobViewRequests.getJob();

			$scope.templates = {};
			$scope.unsubscribe = new Rx.Subject();
			$scope.fundyIntegration = false;
			$scope.fundyLoadXml = false;
			$scope.fundyAvailable = false;

			settingsService.timeFormatSettings.subscribe(data => {
				if (data.fundyAvailable) {
					$scope.fundyAvailable = true;
					if (data.fundyIntegration === 'ENABLED') {
						$scope.fundyIntegration = true;
					}
				}
			});

			Rx.Observable.zip(
				templateRequestsService.getTemplates('contract_preview'),
				templateRequestsService.getTemplates('questionnaire_preview'),
				templateRequestsService.getTemplates('general_preview')
			)
				.takeUntil($scope.unsubscribe)
				.subscribe(
					([contracts, questionnaires, general]) => {
						setContractsPreview(contracts);
						setQuestionnairesPreview(questionnaires);
						setGeneralEmailsPreview(general);
					},
					error => showGeneralErrorMessage(error)
				);
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.redirectToNewInvoice = jobId => {
			goToNewPayment(`/jobs/${jobId}/invoice/new`);
			$scope.fundyLoadXml = true;
		};

		$scope.openFileUploadModal = event => {
			event.preventDefault();
			document.getElementById('fundyUpload').click();
		};

		$scope.addNewInvoiceFromModal = jobId => {
			if ($scope.fundyIntegration) {
				$scope.createNewInvoiceSpinningWheel = true;
				const selectModal = '#addNewModal';
				const nextModal = '#addNewInvoiceWithFundy';
				utilsService.showNextModal(selectModal, nextModal);
				$timeout(() => {
					$scope.createNewInvoiceSpinningWheel = false;
				}, 1000);
			} else {
				goToNewPayment(`/jobs/${jobId}/invoice/new`);
			}
		};

		$scope.importInvoiceFromFundy = item => {
			const jobId = $scope.job.id;
			$scope.fundyLoadXml = true;

			fileUploadDataService
				.sendFileXml(item, jobId)
				.finally(() => {
					$scope.fundyLoadXml = false;
				})
				.subscribe(result => {
					$scope.fundyLoadXml = false;
					const invoiceId = result.invoiceId;
					messageService.showToaster('s_2', 'fundy');
					$('#addNewInvoiceWithFundy').modal('hide');
					goToLocation(`/invoices/${invoiceId}`);
				});
		};

		$scope.createNewInvoice = jobId => {
			$scope.createNewInvoiceSpinningWheel = true;
			if ($scope.fundyIntegration) {
				$('#addNewInvoiceWithFundy')
					.modal('show')
					.on('shown.bs.modal', () => {
						$scope.createNewInvoiceSpinningWheel = false;
					});
			} else {
				goToNewPayment(`/jobs/${jobId}/invoice/new`);
			}
		};

		const id = $routeParams.jobId;
		$scope.saveFilesOnService = (item, jobId) => {
			$scope.loadFileSpinningWheelActive = true;

			if ($scope.loadFileSpinningWheelActive === true) {
				$('.btn-add-round').css('pointer-events', 'none');
			}

			const maxMb = 20; // 20 Mb
			const maxSize = maxMb * 1000 * 1024;

			const totalFilesSize = getTotalSize($scope.files);

			if (totalFilesSize + item.size > maxSize) {
				messageService.showToaster('w_1', 'attachments');
				$scope.loadFileSpinningWheelActive = false;
				return;
			}

			fileUploadService.saveFileOnServer(
				item,
				jobId,
				response => {
					response.convertedType = imageConverter.getFileClass(response.name);
					$scope.files.push(response);
					fileUploadService.setFiles(response);
					$scope.loadFileSpinningWheelActive = false;
					$scope.$broadcast('addedFileEvent');
					if ($scope.loadFileSpinningWheelActive === false) {
						$('.btn-add-round').css('pointer-events', 'auto');
					}
				},
				response => {
					console.log(response);
				}
			);
		};

		$scope.saveAttachment = function(fileId, jobId) {
			fileDownloadDataService.saveFile(fileId, jobId);
		};

		function getTotalSize(files) {
			return files.reduce((prev, next) => prev + next.bytesSize, 0);
		}

		$scope.deleteFile = file => {
			$scope.file = file;
			$('#deleteAttachmentModal').modal('show');
		};

		$scope.$on('removedFileEvent', event => {
			$scope.$broadcast('removedData');
		});

		$scope.disableDragDrop = function() {
			return true;
		};

		// initial setup
		$scope.dateFilterJobMail = "dd MMMM yyyy 'at' HH:mm";

		$scope.mailData2Save = {};
		$scope.contractData2Send = {};
		$scope.job2Edit = {};
		$scope.clientEmails = [];

		let clientsEmailTimer;

		// attachments
		clearQuestAttachments();
		clearContractAttachments();

		// templates for workflow tasks
		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.questionnaires = angular.copy(
				data.questionnaireTemplates
			);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		// Watchers
		$scope.$watchCollection('sendMessageContract', (newValue, oldValue) => {
			if (newValue != oldValue) {
				if (!newValue.emailCc) {
					if ($('.in#sendNewContractModal').length > 0) {
						$scope.sendMessageContract.emailCc =
							$('.input-emailCc').val() || '';
					} else {
						$scope.sendMessageContract.emailCc = '';
					}
				}

				if (
					$scope.sendMessageContract &&
					$scope.sendMessageContract.emailCc &&
					$scope.sendMessageContract.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessageContract.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		$scope.$watchCollection('sendMessageQuestion', (newValue, oldValue) => {
			if (newValue != oldValue) {
				if (!newValue.emailCc) {
					if ($('.in#sendNewQuestionnaireModal').length > 0) {
						$scope.sendMessageQuestion.emailCc =
							$('#sendFirstQuestionnaireMessageData_emailCc').val() || '';
					} else {
						$scope.sendMessageQuestion.emailCc = '';
					}
				}

				if (
					$scope.sendMessageQuestion &&
					$scope.sendMessageQuestion.emailCc &&
					$scope.sendMessageQuestion.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessageQuestion.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		$scope.$watchCollection('sendMessage', (newValue, oldValue) => {
			if (newValue != oldValue) {
				if (!newValue.emailCc) {
					if ($('.in#sendNewContractModal').length > 0) {
						$scope.sendMessage.emailCc =
							$('#sendFirstContractMessageData_emailCc').val() || '';
					} else if ($('.in#sendNewQuestionnaireModal').length > 0) {
						$scope.sendMessage.emailCc =
							$('#sendFirstQuestionnaireMessageData_emailCc').val() || '';
					} else if ($('.in#sendContractModal').length > 0) {
						$scope.sendMessage.emailCc =
							$('#sendContractMessageData_emailCc').val() || '';
					} else {
						$scope.sendMessage.emailCc = '';
					}
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		$scope.$watch('primaryContact', newValue => {
			if (newValue) {
				$rootScope.primaryContact = $scope.primaryContact;
			}
		});

		// Contract methods
		$scope.initSendContract = () => {
			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService.getTemplates('contract_preview').subscribe(
				data => {
					successInitSendContract(data);
					$timeout(() => {
						$('#sendNewContractModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendNewContractModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}, DELAY);
				},
				error => messageService.showDefaultErrorMessage(error)
			);
		};

		function successGetJobInfo(data) {
			$scope.job = JSON.parse(JSON.stringify(data));
			$rootScope.jobId = $scope.job.id;
			prepareJob(data);
			prepareTasks();
			setContacts();
			calculateInvoices();
			setAttachments(data.attachments);
			$scope.getMails(false);

			$location.search({}).replace();
		}

		function errorGetJobInfo(error) {
			const { errorCode, data } = error.error;
			if (errorCode === 702) {
				$location.path(`/${data.redirectTo}s/view/${data.redirectId}`);
			}
		}

		function successInitSendContract(data) {
			$scope.initSendContractSpinningWheel = true;
			$scope.contractSendSource = data;
			$scope.contracts = $scope.contractSendSource.contractTemplates;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if ($scope.contractEmailTemplates) {
				const template =
					$scope.contractEmailTemplates.find(
						item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
					) || {};

				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}

			delete $scope.sendMessageContract;
			$scope.sendMessageContract = {};
			$scope.sendMessageContract.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessageContract.emailCc = '';
			$scope.initSendContractSpinningWheel = false;
		}

		$scope.showSendContract = function(jobId, jobContractId, task) {
			$routeParams.contractId = jobContractId;
			$routeParams.jobId = jobId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';
			if (task !== undefined) {
				$scope.sendMessage.task = JSON.parse(JSON.stringify(task));
				$scope.sendMessage.jobId = jobId;
				$scope.sendMessage.sortedTasksArr = $scope.sortedTasksArr;
				$scope.sendMessage.isDisable = true;
			}
			templateRequestsService
				.getTemplates('contract_preview')
				.subscribe(data => successShowSendContract(data));

			$http({
				method: 'GET',
				url: `/protected/rest/contracts/get/view/${jobId}/${jobContractId}`
			})
				.then(result => {
					$scope.contract = result.data.contract;
					$scope.$evalAsync();
				})
				.catch(messageService.showDefaultErrorMessage);
		};

		function successShowSendContract(data) {
			$scope.contractSendSource = data;
			$scope.contractEmailTemplates = $scope.contractSendSource.emailTemplates;
			if (
				$scope.contractEmailTemplates &&
				$scope.contractEmailTemplates.length > 0
			) {
				const template =
					$scope.contractEmailTemplates.find(
						item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
					) || {};
				$scope.chosenContractEmail = template;
				$scope.setContractEmailTemplate(template.id);
			}
			$('#sendContractModal')
				.modal('show')
				.on('shown.bs.modal', () => {
					const input = $('#sendContractModal').find('input');

					validationService.isModalClosePrevented(input);
				});
		}

		$scope.getMails = function(syncReply) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = true;
			}
			const subscription = mailsDataService
				.getJobMails($scope.jobId, syncReply)
				.subscribe(
					data => successGetMails(data.data, syncReply, subscription),
					error => errorGetMails(error, syncReply, subscription)
				);
		};

		function successGetMails(data, syncReply, subscription) {
			const { lastSyncResult, mails } = data;
			$scope.job.mails = mails;

			// check if google gmail service synchronized
			if (lastSyncResult && lastSyncResult != null) {
				// Show time for synchronized block
				$scope.isGoogleMailSynchronized = true;
				$scope.googleMailLastSyncDate = lastSyncResult.replySynchronizedAt;

				if (syncReply) {
					showCorrectMessage(lastSyncResult);
				}
			}
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			subscription.unsubscribe();
		}

		function showCorrectMessage(lastSyncResult) {
			const status = lastSyncResult.status.toLowerCase();
			const messageType = messageService.getCorrectMessageType(status);

			if (status === 'ok') {
				messageService.showToaster('s_0', 'email');
			} else {
				messageService.showMessageFromBackend(
					messageType,
					lastSyncResult.messageDetails.title,
					lastSyncResult.messageDetails.message
				);
			}
		}

		function errorGetMails(error, syncReply, subscription) {
			if (syncReply) {
				$rootScope.isMailResyncInProcess = false;
			}
			messageService.showDefaultErrorMessage(error);
			subscription.unsubscribe();
		}

		// ATTENTION: Temporary hotfix, to resolve SN-2444.
		function removeJobMails(data) {
			data.mails = [];
			return data;
		}

		$scope.showSendContractModal = e => {
			$scope.contractData2Send = undefined;

			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			const url = '/protected/rest/job/contract/sources';

			$http({
				method: 'GET',
				url
			})
				.then(result => {
					$scope.contractData2Send = angular.copy(result.data);
					$scope.contractData2Send.contracts = result.data.contractTemplates;
					$scope.contractData2Send.contractEmailTemplates =
						result.data.emailTemplates;
					$scope.contractData2Send.mailSignature = result.data.signature || '';
					$scope.contractData2Send.emailTo = $rootScope.primaryContact.email;
					$scope.contractData2Send.jobId = $scope.job.id;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$timeout(() => {
						$('#sendFirstContractModal').modal('show');
					}, DELAY);
				})
				.catch(messageService.showDefaultErrorMessage);
		};

		$scope.editContract = (id, e) => {
			if (id && !$scope.updatedContract) {
				const editContractTemplateCallback = data => {
					$scope.editableContract = angular.copy(data);
				};

				templateRequestsService
					.getTemplates('contract_full', id)
					.subscribe(
						data => editContractTemplateCallback(data),
						error => showGeneralErrorMessage(error)
					);
			} else if ($scope.updatedContract) {
				$scope.editableContract = angular.copy($scope.updatedContract);
			} else if (!$scope.editableContract) {
				$scope.editableContract = {
					text: ''
				};
			}
			utilsService.showNextModal(
				'#sendNewContractModal',
				'#editContractModal',
				e
			);
		};

		$scope.closeEditContract = () => {
			$('#editContractModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					$('#sendNewContractModal').modal('show');
					$scope.editableContract = null;
					$(this).off('hidden.bs.modal');
				});
		};

		$scope.saveEditedContract = () => {
			$scope.isEditContractModalSpinnningWheelActive = true;
			const contractName = stringModifierService.cutSelectedText(
				$scope.editableContract.name
			);
			messageService.showToaster('s_2', 'contractTemplates', contractName);
			$('#editContractModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					$scope.updatedContract = $scope.editableContract;
					$('#sendNewContractModal').modal('show');
					$(this).off('hidden.bs.modal');
					$scope.isEditContractModalSpinnningWheelActive = false;
				});
		};

		$scope.setContractEmailTemplate = id => {
			const contractSetEmailCallback = data => {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataContract = {
						attachments: fileUploadService.convertAttachmentsToShow(
							data.storedAttachments
						)
					};
				} else {
					clearContractAttachments();
				}
			};
			templateRequestsService
				.getTemplates('full_template', id)
				.subscribe(
					data => contractSetEmailCallback(data),
					error => showGeneralErrorMessage(error)
				);
		};

		$scope.sendNewContractEmail = (
			chosenContract,
			updatedContract,
			contractEmailTemplate
		) => {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsDataContract &&
				$scope.attachmentsDataContract.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendContractSpinningWheel = false;
				return false;
			}

			let _emailText = '';

			if (validationService.isStringEmpty(contractEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if ($scope.sendMessage && $scope.sendMessage.emailText) {
				_emailText = $scope.sendMessage.emailText;
			} else {
				_emailText = $('.in .textarea-quad textarea').val();
			}

			if (!$scope.sendMessage) {
				$scope.sendMessage = {};
			}

			$scope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);

			if (
				validateNewContractEmail(
					contractEmailTemplate,
					updatedContract,
					chosenContract
				)
			) {
				const obj2save = angular.copy($scope.sendMessageContract);
				const emailCC2save = $scope.showCcField ? obj2save.emailCc : '';
				const contract2Save = updatedContract
					? updatedContract.text
					: chosenContract.text;

				const data = {
					emailTo: $scope.sendMessageContract.emailTo,
					emailCc: emailCC2save,
					emailText: contractEmailTemplate.text,
					emailSubject: contractEmailTemplate.subject,
					contractId: chosenContract ? chosenContract.templateId : null,
					jobId: $scope.job.id,
					templateId: contractEmailTemplate.id
				};

				if (contract2Save) {
					data.contractText = contract2Save;
				}

				$scope.button_disable = true;
				jobViewRequests.sendNewContractEmail(
					data,
					data => {
						jobViewRequests.getJob();
						$scope.button_disable = false;
						$('#sendNewContractModal').modal('hide');

						$scope.showCcField = false;
						$scope.$evalAsync();
						$('#sendNewQuestionnaireModal').modal('hide');

						for (const prop in $scope.sendMessage) {
							$scope.sendMessage[prop] = '';
						}
						for (const prop in $scope.sendMessageContract) {
							$scope.sendMessageContract[prop] = '';
						}

						if (
							$scope.attachmentsDataContract &&
							$scope.attachmentsDataContract.attachments
						) {
							if ($scope.attachmentsDataContract.attachments.length) {
								$scope.attachmentsDataContract.attachments.length = 0;
							}
						}

						// toastr.success("Contract successfully sent!")
						messageService.showToaster('s_4', 'jobView');
					},
					({ status, data }) => {
						$scope.button_disable = false;
						const path = $location.path();
						const errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status == 423) {
								const limit = $rootScope.isUserTrial ? 50 : 150;
								return messageService.showToaster(
									'e_4',
									'generalValidation',
									limit
								);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster(
									'e_1',
									'generalValidation',
									$scope.sendMessageContract.emailTo
								);
							} else if (path.includes('jobs')) {
								messageService.showToaster('e_0', 'contract');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						} else {
							messageService.showToaster('e_0', 'general');
						}
					}
				);
			}
		};

		function validateNewContractEmail(
			emailTemplate,
			updatedContract,
			chosenContract
		) {
			if (!updatedContract && !chosenContract) {
				messageService.showToaster('w_0', 'jobView');
				return false;
			}

			if (!emailTemplate) {
				messageService.showToaster('e_0', 'general');
				return false;
			}

			if (!emailTemplate.subject) {
				messageService.showToaster('e_5', 'workflow');
				return false;
			}

			if (
				!emailTemplate.text ||
				!emailTemplate.text.includes('%contract_link%')
			) {
				console.log('fire');
				messageService.showToaster('e_2', 'emailTemplate');
				return false;
			}

			return true;
		}

		// Invoice methods
		$scope.showSendInvoice = function(invoiceId) {
			$routeParams.id = invoiceId;

			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.addInvoiceAttachment = true;

			$http({
				method: 'GET',
				url: '/protected/rest/email_templates/get'
			})
				.then(result => {
					if (result.data) {
						$scope.emails = result.data;
						if ($scope.emails && $scope.emails.length > 1) {
							$scope.choosenEmail =
								$scope.emails.find(
									item => item.emailTemplateType === 'INVOICE_EMAIL_TEMPLATE'
								) || {};
						}

						$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
						$scope.sendMessage.emailCc = '';
						$('#sendInvoiceModal')
							.modal('show')
							.on('shown.bs.modal', function() {
								const input = $(this).find('input');
								const select = $(this).find('select');

								validationService.isModalClosePrevented(input);
								validationService.isModalClosePrevented(select);
							});
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		};

		function calculateInvoices() {
			$scope.paymentsTotal = 0;
			$scope.paymentsBalanceDue = 0;
			$scope.recentInvoice = null;
			$scope.nextInvoice = null;
			$scope.job.payments = $filter('orderBy')(
				$scope.job.invoices,
				'invoiceDue',
				false
			);

			if ($scope.job && $scope.job.payments) {
				angular.forEach($scope.job.payments, (value, key) => {
					$scope.paymentsTotal += value.amount;
					if (value.editable) {
						if ($scope.nextInvoice == null) {
							$scope.nextInvoice = value;
						}
						$scope.paymentsBalanceDue += value.amount;
					} else if ($scope.recentInvoice == null) {
						$scope.recentInvoice = value;
					}
				});
				if ($scope.recentInvoice == null) {
					$scope.recentInvoice = $scope.nextInvoice;
				}
			}
		}

		// Quotes methods
		$scope.showNewQuote = () => {
			const selectModal = '#addNewModal';
			const nextModal = '#addNewQuoteTypeModal';
			utilsService.showNextModal(selectModal, nextModal);
		};

		$scope.createNewQuote = (job, quoteType) => {
			const { id } = job;
			goToNewPayment(`/jobs/${id}/quote/${quoteType}/new`);
		};

		$scope.showAddNewQuoteModal = () => {
			$('#addNewQuoteTypeModal').modal('show');
		};

		// Questionnaire methods
		$scope.initSendQuestionnaire = () => {
			$('#sendFirstQuestionnaireMessageData_emailCc').val('');

			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			templateRequestsService
				.getTemplates('questionnaire_preview')
				.subscribe(data => {
					successInitSendQuestionnaire(data);
					$timeout(() => {
						$('#sendNewQuestionnaireModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendNewQuestionnaireModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}, DELAY);
				});
		};

		function successInitSendQuestionnaire(data) {
			$scope.initSendQuestionnaireSpinningWheel = true;
			$scope.questionnaireSendSource = data;
			$scope.questionnaires =
				$scope.questionnaireSendSource.questionnaireTemplates;
			$scope.questionnaireEmailTemplates =
				$scope.questionnaireSendSource.emailTemplates;

			const template =
				$scope.questionnaireEmailTemplates.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {};

			$scope.choosenQuestionnaireEmail = template;

			if ($scope.questionnaireEmailTemplates) {
				$scope.setQuestionnaireEmailTemplate(template.id);
			}

			delete $scope.sendMessageQuestion;
			$scope.sendMessageQuestion = {};
			$scope.sendMessageQuestion.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessageQuestion.emailCc = '';
			$scope.initSendQuestionnaireSpinningWheel = false;
		}

		$scope.showSendQuestionnaire = (jobId, questionnaireId, task) => {
			$rootScope.showCcField = false;
			$routeParams.questionnaireId = questionnaireId;
			$routeParams.jobId = jobId;

			// delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';
			if (task !== undefined) {
				$scope.task = JSON.parse(JSON.stringify(task));
				$scope.sortedTasksArrQuestionnarie = $scope.sortedTasksArr;
				$scope.isDisable = true;
			}
			templateRequestsService
				.getTemplates('questionnaire_preview')
				.subscribe(data => successShowSendQuestionnaire(data));
		};

		function successShowSendQuestionnaire(data) {
			$scope.questionnaireSendSource = data;
			$scope.questionnaireEmailTemplates = data.emailTemplates;

			const template =
				$scope.questionnaireEmailTemplates.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {};

			$scope.choosenQuestionnaireEmail = template;
			$scope.setQuestionnaireEmailTemplate(template.id);

			$('#sendQuestionnaireModal')
				.modal('show')
				.on('shown.bs.modal', () => {
					const input = $('#sendQuestionnaireModal').find('input');

					validationService.isModalClosePrevented(input);
				});
		}

		$scope.setQuestionnaireEmailTemplate = id => {
			const questionnaireSetEmailCallback = data => {
				$scope.questionnaireEmail = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsDataQueston = {
						attachments: fileUploadService.convertAttachmentsToShow(
							data.storedAttachments
						)
					};
				} else {
					clearQuestAttachments();
				}
			};
			templateRequestsService
				.getTemplates('full_template', id)
				.subscribe(
					data => questionnaireSetEmailCallback(data),
					error => showGeneralErrorMessage(error)
				);
		};

		$scope.sendNewQuestionnaireEmail = function(
			chosenQuestionnaire,
			questionnaireEmailTemplate
		) {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsDataQueston &&
				$scope.attachmentsDataQueston.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.initSendQuestionnaireSpinningWheel = false;
				$scope.button_disable = false;
				return false;
			}

			if (validationService.isStringEmpty(questionnaireEmailTemplate.subject)) {
				messageService.showToaster('e_10', 'emailTemplate');
				return;
			}

			if (
				$scope.questionnaireEmail &&
				$scope.questionnaireEmail.text &&
				chosenQuestionnaire
			) {
				if (
					questionnaireEmailTemplate &&
					questionnaireEmailTemplate.text &&
					questionnaireEmailTemplate.subject
				) {
					questionnaireEmailTemplate.text = $rootScope.addMaiStyling(
						questionnaireEmailTemplate.text
					);

					const obj2save = angular.copy($scope.sendMessageQuestion);
					const emailCC2save = $scope.showCcField ? obj2save.emailCc : '';

					const data = {
						emailTo: $scope.sendMessageQuestion.emailTo,
						emailCc: emailCC2save,
						emailText: questionnaireEmailTemplate.text,
						emailSubject: questionnaireEmailTemplate.subject,
						questionnaireTemplateId: chosenQuestionnaire.id || null,
						jobId: $scope.job.id,
						templateId: questionnaireEmailTemplate.id
					};
					$scope.button_disable = true;
					jobViewRequests.sendNewQuestionnaireEmail(
						data,
						data => {
							jobViewRequests.getJob();
							$scope.button_disable = false;
							$scope.showCcField = false;
							$scope.$evalAsync();
							$('#sendNewQuestionnaireModal').modal('hide');

							for (const prop in $scope.sendMessageQuestion) {
								$scope.sendMessageQuestion[prop] = '';
							}
							if (
								$scope.attachmentsDataQueston &&
								$scope.attachmentsDataQueston.attachments
							) {
								if ($scope.attachmentsDataQueston.attachments.length) {
									$scope.attachmentsDataQueston.attachments.length = 0;
								}
							}
							messageService.showToaster('s_9', 'jobView');
						},
						({ status, data }) => {
							$scope.button_disable = false;
							const path = $location.path();
							const errorMessage = data.errorMessage;

							if (status >= 400 && status < 500 && errorMessage) {
								if (status === 423) {
									const limit = $rootScope.isUserTrial ? 50 : 150;
									return messageService.showToaster(
										'e_4',
										'generalValidation',
										limit
									);
								} else if (errorMessage.includes('Email address inactive')) {
									messageService.showToaster(
										'e_1',
										'generalValidation',
										$scope.sendMessageQuestion.emailTo
									);
								} else if (path.includes('jobs')) {
									messageService.showToaster('e_0', 'questionnaires');
								} else {
									messageService.showToaster('e_2', 'general', errorMessage);
								}
							} else {
								messageService.showToaster('e_0', 'general');
							}
						}
					);
				} else {
					// toastr.warning("Fill data first");
					messageService.showToaster('w_0', 'jobView');
				}
			} else {
				// toastr.warning("Fill data first");
				messageService.showToaster('w_0', 'jobView');
			}
		};

		// Notes methods
		$scope.showEditNotesModal = () => {
			$scope.editNotes = $scope.job.notes || '';
			$('#updateModal').modal('show');
		};

		$scope.saveNotes = () => {
			$scope.isSaveNotesSpinnningWheelActive = true;
			const notesTmp = $rootScope.addMaiStyling($scope.editNotes);

			const data4Save = {
				id: $scope.job.id,
				notes: notesTmp
			};

			$http({
				method: 'POST',
				url: '/protected/rest/job/notes/update',
				data: data4Save
			})
				.then(result => {
					const { message, errorMessage } = result.data;

					if (message) {
						messageService.showToaster('s_3', 'jobView');
						$('#updateModal').modal('hide');
						// $rootScope.updateEditJobModalData = true;
						$scope.job.notes = notesTmp;
						$scope.job2Edit.notes = notesTmp;
					} else {
						toastr.error(errorMessage);
					}
				})
				.catch(messageService.showDefaultErrorMessage)
				.finally(() => {
					$scope.isSaveNotesSpinnningWheelActive = false;
				});
		};

		$scope.setClientMail = (clientMailData, jobMailData) => {
			$scope.clientMailData = clientMailData;
			$scope.mailData2Save = jobMailData;
		};

		// Email methods
		$scope.showSendEmailModal = function(data, jobId, task) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => ($scope.showSendEmailModalSpinningWheel = false))
				.subscribe(([emails, mailSignature]) => {
					$scope.mailData2Save = angular.copy(data);
					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';
					if (task !== undefined) {
						$scope.mailData2Save.emailSubject = task.taskEmail.subject;
						$scope.mailData2Save.emailText = task.taskEmail.text;
						$scope.mailData2Save.task = JSON.parse(JSON.stringify(task));
						$scope.mailData2Save.jobId = $scope.job.id;
						$scope.mailData2Save.sortedTasksArr = $scope.sortedTasksArr;
						$scope.mailData2Save.isDisable = true;
					}

					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$routeParams.jobId = jobId;
					$scope.jobId = jobId;
					$('#sendContactEmailModal').modal('show');
				});
		};

		$scope.showSendModal = function(task) {
			if (task.completed === true) {
				switch (task.action) {
					case 'SEND_EMAIL':
						$scope.showSendEmailModal(
							$scope.primaryContact,
							$scope.jobId,
							task
						);
						break;
					case 'SEND_QUESTIONNAIRE':
						$scope.tickTask = true;
						$scope.tickTaskType = 'QUESTIONNAIRE';
						openEditAutomationTask(task);
						break;
					case 'SEND_CONTRACT':
						$scope.tickTask = true;
						$scope.tickTaskType = 'CONTRACT';
						openEditAutomationTask(task);
						break;
				}
			}
		};

		function openEditAutomationTask(task) {
			workflowService.setTaskInfo(task, $scope.job.workflow.tasks, true);
			$('#addAutomationModal').modal('show');
		}

		$scope.retrySendMail = function() {
			jobViewRequests.getJob();
			emailService.callLastEmailFn();
		};

		$scope.openSendEmailForReply = function() {
			utilsService.closeAllModalsAndOpenNew('#sendContactEmailModal');
		};

		$scope.updateClientToResubscribe = function(client) {
			$scope.clientToSendMail = client;
		};

		$scope.setEmail = function(site, object) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			if (!object) {
				$scope.sendMessage.emailCc = stringEmail;
			} else {
				object.emailCc = stringEmail;
			}
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		function emailSearchRequest(search) {
			clientsDataService
				.searchClient(search)
				.subscribe(
					data => findClientSuccessCallback(data),
					err => messageService.showDefaultErrorMessage(err)
				);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};

		// attachments

		function setAttachments(attachments) {
			$scope.files = fileUploadService.setAttachmentsFromServer(attachments);
			$scope.$broadcast('addedFileEvent');
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		// Workflow methods
		$scope.getWorkflow = () => {
			if (
				!$scope.job ||
				$scope.job.id === null ||
				$scope.job.id === undefined
			) {
				return false;
			}
			workflowService.getJobWorkflow($scope.job.id, successGetWorkflow);
		};

		function successGetWorkflow(workflow) {
			$scope.job.workflow = workflow;
			prepareTasks();
		}

		const fillWorkflowTasks = (taskList = []) => {
			[
				$scope.lead,
				$scope.production,
				$scope.postProduction
			] = workflowService.fillWorkflowTasks(taskList);
		};

		const handleTask = (task, taskTypes) => {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				const {
					startDate,
					finishDate,
					startTime,
					finishTime,
					location
				} = $scope.job;
				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				const {
					startDate,
					endDate,
					startTime,
					endTime,
					location,
					clientId
				} = task.calendarEvent;
				task.location = location;
				task.startDate = startDate;
				task.endDate = endDate;
				task.startTime = startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (
					task.startDate &&
					(task.startTime === null || task.finishTime === null)
				) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault =
				task.defaultTask && task.dueDate ? task.dueDate : null;
		};

		const getSortedTasks = () => [
			$scope.lead,
			$scope.production,
			$scope.postProduction
		];

		function prepareTasks() {
			if (!$scope.job.workflow) {
				return false;
			}

			let taskList = angular.copy($scope.job.workflow.tasks);
			taskList = $filter('orderBy')($scope.job.workflow.tasks, 'number', false);
			fillWorkflowTasks(taskList);

			$scope.sortedTasksArr = getSortedTasks();
			$scope.job.workflow.tasks.forEach(item =>
				handleTask(item, $scope.sortedTasksArr)
			);

			if ($scope.job.showNewTaskId) {
				$timeout(() => {
					const newTask = taskList.find(
						task => task.id === $scope.job.showNewTaskId
					);
					const taskToAnimate = `.task-${newTask.number}`;
					$rootScope.$broadcast('animateTask', taskToAnimate);
				}, 0);
			}
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		}

		$scope.renewWorkflow = tasks => {
			let taskList = angular.copy(tasks);
			taskList = $filter('orderBy')(tasks, 'number', false);
			fillWorkflowTasks(taskList);
			$scope.sortedTasksArr = getSortedTasks();
			taskList.forEach(item => handleTask(item, $scope.sortedTasksArr));
			$scope.correctSortedTasksArray = angular.copy($scope.sortedTasksArr);
		};

		$scope.showWarningModal = function(task) {
			if (task) {
				emailService.emitClientToCheckSubscription($scope.primaryContact);
				emailService.checkIfEmailAllowedWeb(
					$scope.primaryContact,
					$scope.changeTaskState,
					this,
					[task]
				);
				$scope.retryTask = task;
			}
		};

		$scope.cancelAutomation = function() {
			if ($scope.retryTask) {
				$scope.retryTask.completed = false;
			}
		};

		$scope.changeTaskState = task => {
			$rootScope.dnd.canMove = false;
			$http({
				method: 'POST',
				url: `/protected/rest/jobs/${$scope.job.id}/tasks/${task.id}`,
				data: JSON.stringify(task.completed)
			})
				.then(
					result => {
						toastr.clear();
						messageService.showToaster('i_0', 'jobView');
						task = Object.assign(task, result.data);
						handleTask(task, $scope.sortedTasksArr);
						jobViewRequests.getJob();
					},
					result => {
						toastr.clear();
						if (result.status === 423) {
							const limit = $rootScope.isUserTrial ? 50 : 150;
							messageService.showToaster('e_4', 'generalValidation', limit);
						} else {
							messageService.showDefaultErrorMessage(result);
						}
					}
				)
				.finally(() => {
					$rootScope.dnd.canMove = true;
				});
		};
		$scope.changeToLeadOrJob = task => {
			$('#modalChangeLead').modal('show');
			$scope.newTaskCreate = Object.assign(task);
		};
		// Client methods
		function setContacts() {
			const { primaryContact, secondaryContact } = $scope.job;
			$scope.primaryContact = primaryContact;

			if (secondaryContact) {
				$scope.secondaryContact = secondaryContact;
			}
		}

		$scope.chooseContract = () => {
			$scope.updatedContract = null;
		};

		$scope.editClient = client => {
			$scope.clientForEdit = angular.copy(client);
			$scope.companyNameChecked =
				!!$scope.clientForEdit.companyName ||
				!!$scope.clientForEdit.businessNumber;
			$('#editClientModal')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};

		const successSaveClient = data => {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
				$scope.isCreateClientModalSpinnningWheelActive = false;
			} else {
				toastr.success(data.message, 'Success');
				$('#editClientModal').modal('hide');
				delete $scope.clientForEdit;
				jobViewRequests.getJob();
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		const errorSaveClient = ({ status, data }) => {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage ===
					'Job contact cannot be changed because invoice has Xero payment'
				) {
					errorCode = 'e_10';
					errorPlace = 'xero';
				} else if (
					errorMessage === 'Sorry, this customer has been deleted on QuickBooks'
				) {
					errorCode = 'e_23';
					errorPlace = 'qb';
				} else if (errorMessage.includes('already registered')) {
					errorCode = 'e_8';
					errorPlace = 'clients';
					value = $scope.clientForEdit.email;
				} else if (
					errorMessage ===
					'Your QuickBooks company already contains client with such name'
				) {
					errorCode = 'e_6';
					errorPlace = 'qb';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		};

		$scope.saveClient = () => {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (!$scope.clientForEdit.id) {
				console.error('No client id');
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return;
			}
			if (!validationService.isEmailValid($scope.clientForEdit.email)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (validationService.isStringEmpty($scope.clientForEdit.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!$scope.companyNameChecked) {
				delete $scope.clientForEdit.companyName;
				delete $scope.clientForEdit.businessNumber;
			}

			if ($scope.clientForEdit.notes) {
				$scope.clientForEdit.notes = $rootScope.addMaiStyling(
					$scope.clientForEdit.notes
				);
			}

			clientsDataService
				.updateClient($scope.clientForEdit)
				.finally(() => ($scope.isCreateClientModalSpinnningWheelActive = false))
				.subscribe(
					data => successSaveClient(data),
					err => errorSaveClient(err)
				);
		};

		// Go-to methods
		function goToLocation(url) {
			$location.path(url);
		}

		function goToNewPayment(url) {
			const addNewModal = $('#addNewModal');
			let delay = 0;

			if (addNewModal.hasClass('in')) {
				addNewModal.modal('hide');
				delay = 500;
			}

			$timeout(() => goToLocation(url), delay);
		}

		$scope.goToQuotePage = (jobId, quoteId) =>
			goToLocation(`/jobs/${jobId}/quote/${quoteId}`);

		$scope.goToInvoicePage = (job, invoice) => {
			const { hasInvoices } = job;
			const { invoiceId } = invoice;

			if (hasInvoices) {
				goToLocation(`/invoices/${invoiceId}`);
			}
		};

		$scope.goToContractsPage = (jobId, contractId) =>
			goToLocation(`/jobs/view/${jobId}/contracts/${contractId}`);

		$scope.goToQuestionnairesPage = (jobId, questionnaireId) =>
			goToLocation(`/jobs/view/${jobId}/questionnaires/${questionnaireId}`);

		// Toggle modals
		$scope.showAddNewModal = () => {
			$('#addNewModal').modal('show');
		};

		$scope.showDeleteModal = jobId => {
			$scope.jobForDelete = jobId;
			$('#deleteModal').modal('show');
		};

		$scope.showEditJobModal = job => {
			$scope.job2Edit.workflow.name = stringModifierService.addSelectedText(
				$scope.job2Edit.workflow.name
			);
			const isWorkflowSaved = $scope.job2Edit.workflowNames.find(
				workflow => workflow.id === $scope.job2Edit.workflow.id
			);
			if ($scope.job2Edit.workflowNames && !isWorkflowSaved) {
				$scope.job2Edit.workflowNames.push($scope.job2Edit.workflow);
			}
			$('#newJob').modal('show');

			$scope.$broadcast('showModalJob', $scope.job2Edit);
		};

		$scope.showAddNewTaskModal = () => {
			$scope.showAddNewTaskModalSpinnigWheel = true;
			const addNewModal = $('#addNewModal');
			let DELAY = 500;

			if (addNewModal.hasClass('in')) {
				$('#addNewModal').modal('hide');
			} else {
				DELAY = 0;
			}

			$timeout(() => {
				$('#addWorkflowTaskModal').modal('show');
				$scope.showAddNewTaskModalSpinnigWheel = false;
			}, DELAY);
		};

		$scope.showQuoteModal = (jobId, quoteId) => {
			$routeParams.jobId = jobId;
			$routeParams.quoteId = quoteId;

			$scope.sendMessage = {};
			$scope.sendMessage.emailTo = $rootScope.primaryContact.email;
			$scope.sendMessage.emailCc = '';

			$http.get('/protected/rest/email_templates/get').then(result => {
				if (result.data) {
					$scope.emails = result.data;
					if (result.data.length > 0) {
						// $scope.choosenEmail = result.data[0];
						$scope.choosenEmail =
							$scope.emails.find(
								item => item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE'
							) || {};
					}
					$('#sendQuoteModal').modal('show');
				}
			});
		};

		// Job methods
		$scope.deleteJob = () => {
			$scope.deleteDisable = true;

			$http({
				method: 'GET',
				url: `/protected/rest/jobs/job/delete?id=${$scope.jobForDelete}`
			})
				.then(result => {
					const { message = '', errorMessage = false } = result.data;

					if (errorMessage) {
						toastr.error(errorMessage, 'Error');
					} else {
						if (message.includes('successfully deleted')) {
							messageService.showToaster('s_0', 'jobView');
						} else {
							toastr.success(message, 'Success');
						}

						$location.path('/jobs');
					}
				})
				.catch(errorDeleteJob)
				.finally(() => {
					$scope.deleteDisable = false;
				});
		};

		function errorDeleteJob({ status, data }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage.includes(
						'This payment cannot be marked as unpaid because it was overpaid in Xero.'
					)
				) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function prepareJob(job) {
			$scope.job2Edit = angular.copy(job);
			$scope.clients = [];

			const {
				workflow,
				startDate,
				finishDate,
				primaryContact,
				secondaryContact
			} = $scope.job2Edit;

			$scope.job2Edit.oldWorkflow = workflow;

			if (!$scope.job2Edit.startDate) {
				$scope.job2Edit.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.job2Edit.hasNoDate = false;
				$scope.job2Edit.startDate = timeService.createDateAsUTC(startDate);
				$scope.job2Edit.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.job2Edit.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.job2Edit.secondaryContact = $scope.clients[1];
			}

			if (
				$scope.job2Edit.startDate &&
				($scope.job2Edit.startTime === null ||
					$scope.job2Edit.finishTime === null)
			) {
				$scope.job2Edit.allday = true;
			}
			getJobTypes();
			getWorkflowNames();
		}

		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.subscribe(data => successGetJobTypes(data));
		}

		function getWorkflowNames() {
			return workflowDataService
				.getWorkflowNames()
				.subscribe(data => successGetWorkflowNames(data));
		}

		function successGetJobTypes(data) {
			$scope.jobTypes = angular.copy(data);
			if (
				!$scope.job2Edit.type &&
				$scope.jobTypes &&
				$scope.jobTypes.length > 0
			) {
				$scope.job2Edit.type = $scope.jobTypes[0];
			}
			$scope.job2Edit.jobTypes = angular.copy(data);
		}

		function successGetWorkflowNames(data) {
			if (!data) {
				return false;
			}
			$scope.job2Edit.workflowNames = angular.copy(data);
		}

		// helper functions
		function showGeneralErrorMessage(error) {
			messageService.showToaster('e_0', 'general');
		}

		$scope.setMinWidth = (text = '') => {
			const textLength = text.length;

			if (textLength < 6) {
				return 40;
			} else if (textLength < 10) {
				return 60;
			} else if (textLength < 20) {
				return 100;
			}
			return 190;
		};

		$rootScope.updateJobView = function() {
			jobViewRequests.getJob();
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/job/jobViewController.js